export default __webpack_public_path__ + "locales/de/Common.json?hash=2d92f7f3a8022b9e48f2dd25c4ed69f0";